export const GET_CONFIG_FETCH = 'config/GET_CONFIG_FETCH';
export const WITHDRAWAL_CONFIG_SUCCESS = 'config/WITHDRAWAL_CONFIG_SUCCESS';
export const FEE_LIST_CONFIG_SUCCESS = 'config/FEE_LIST_CONFIG_SUCCESS';
export const BANK_LIST_CONFIG_SUCCESS = 'config/BANK_LIST_CONFIG_SUCCESS';
export const COUNTRY_UTIL_CONFIG_SUCCESS = 'config/COUNTRY_UTIL_CONFIG_SUCCESS';
export const UPDATE_BANK_CONFIG_SETTINGS = 'config/UPDATE_BANK_CONFIG_SETTINGS';
export const UPDATE_BANK_CONFIG_SETTINGS_SUCCESS = 'config/UPDATE_BANK_CONFIG_SETTINGS_SUCCESS';
